<script setup lang="ts">
defineProps<{
  letter: string
}>()
</script>

<template>
  <h2 class="flex pb-m px-2xs title-l col-span-4">
    {{ letter }}
  </h2>
</template>
